export default {
  title: "",
  subtitle: '',
  path: "person_transactions",
  paragraph: "Before reaching this stage and receiving the webhook, you can check the amount transacted for that specific subject_id in local currency, as well as the number of transactions. You can use the following endpoint to get this information and ask for the documents in advance.",
  request: {
    method: "GET", 
    endpoint: "/subject/:id/transactions",
    responses: {
      "data": [
        {
          "value": "2500.00",
          "to_bank_account_id": "b51dff12-071f-486d-9667-9f3295186e3b",
          "subject_is_receiver": false,
          "status": "identified",
          "source_name": "Gustavo Maia",
          "source_document_type": "cpf",
          "source_document_number": "10000000019",
          "short_id": "AF9DCA5E",
          "meta": {
            "some_external_transaction_id": "TPUP000000894089"
          },
          "inserted_at": "2022-03-08T13:03:20.920784",
          "id": "21d90105-5bcb-465c-8c1d-8a2cb8339ecd",
          "from_credit_card_id": null,
          "from_bank_account_id": "912fccae-d4db-4416-8b44-4e7abb8a47e2",
          "for_exchange": true,
          "exchange_under_request": false,
          "exchange_currency": "USD",
          "estimated_value_until_exchange": false,
          "currency": "BRL",
          "cleared": false,
          "bank_transaction": {
            "wire_id": null,
            "value": "2500.0",
            "source_type": "TED-PRE",
            "source_name": "Gustavo Maia",
            "source_id": "21d90105-5bcb-465c-8c1d-8a2cb8339ecd",
            "source_document_type": "cpf",
            "source_document_number": "10000000019",
            "source_description": "CREDITO POR TED ANTECIPADO",
            "source_branch": null,
            "source_bank": null,
            "source_account": null,
            "movement_date": "2022-03-08",
            "iof_value": null,
            "inserted_at": "2022-03-08T13:03:21.037379",
            "id": "3c113e72-f882-4dd1-b0c5-b4500f9abe2c",
            "exchanged_value": null,
            "exchange_rate": null,
            "exchange_id": null,
            "exchange_currency": "USD",
            "exchange_approved": false,
            "currency": "BRL"
          }
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectPeople/PersonTransactions.js